import { useTranslation, type Lang } from "@ecliptica/i18n";
import { Button } from "@ecliptica/ui";
import { DOWNLOADS, art } from "../../content/site";
import { Section } from "./Section";

const SAGA = ["2", "3", "4", "5"] as const;

export function BooksSection({ lang }: { lang: Lang }) {
  const { t } = useTranslation();
  const dl = DOWNLOADS[lang];
  return (
    <Section id="books" title={t("books.title")} lead={t("books.lead")} bg="/bg/lore.webp">
      <div className="skin-panel mx-auto grid max-w-[900px] items-center gap-7 rounded-2xl border bg-card p-6 md:grid-cols-[220px_1fr]">
        {/* Capa composta com duas ilustrações (mesma da versão estática). */}
        <div className="relative mx-auto grid aspect-[2/3] w-full max-w-[220px] grid-rows-2 overflow-hidden rounded-[6px_12px_12px_6px] border-2 border-gold-dark bg-night shadow-[0_14px_30px_rgba(0,0,0,.55)]">
          <img src={art("ECO-028")} alt="" loading="lazy" className="h-full w-full object-cover" />
          <img src={art("ECO-011")} alt="" loading="lazy" className="h-full w-full object-cover" />
          <span className="absolute inset-x-0 top-[47%] -translate-y-1/2 text-center font-title text-[15px] font-extrabold tracking-[0.3em] text-gold-bright [text-shadow:0_2px_8px_#000]">
            ECLIPTICA
          </span>
          <span className="absolute inset-x-0 top-[54%] text-center font-title text-[13px] text-white [text-shadow:0_2px_8px_#000]">{t("books.book1.t")}</span>
        </div>
        <div>
          <h3 className="text-2xl font-extrabold text-gold">{t("books.book1.t")}</h3>
          <p className="mt-2">{t("books.book1.d")}</p>
          <p className="mt-4 flex gap-3">
            <Button asChild variant="primary">
              <a href={dl.bookPdf} download>
                PDF
              </a>
            </Button>
            <Button asChild>
              <a href={dl.bookEpub} download>
                EPUB
              </a>
            </Button>
          </p>
        </div>
      </div>
      <ol className="mx-auto mt-7 flex max-w-[1000px] list-none flex-wrap justify-center gap-2.5 p-0">
        <li className="rounded-full border border-gold px-3.5 py-2 font-title text-sm text-gold-bright">{t("books.book1.t")}</li>
        {SAGA.map((n) => (
          <li key={n} className="rounded-full border px-3.5 py-2 font-title text-sm text-muted-foreground">
            {t(`books.saga.${n}`)} <em className="font-sans text-xs opacity-80">{t("books.saga.soon")}</em>
          </li>
        ))}
      </ol>
    </Section>
  );
}
